import { supabase } from "@/lib/supabase";
import { withTimeout } from "@/lib/timeout";

export interface GeocodeResult {
  processed: number;
  geocoded: number;
  cached_hits: number;
  failed: number;
}

/**
 * Invokes the `geocode-leads` edge function.
 * Server-side admin check; client gate is cosmetic.
 */
export async function runGeocodeLeads(limit = 200): Promise<GeocodeResult> {
  // Generous cap: the function geocodes sequentially, so big batches are
  // legitimately slow — but a dead connection should not hang the UI forever.
  const { data, error } = await withTimeout(
    supabase.functions.invoke<GeocodeResult>("geocode-leads", {
      body: { limit },
    }),
    150_000,
    "Geocoding",
  );
  if (error) throw error;
  if (!data) throw new Error("Empty response from geocode-leads");
  return data;
}
